module.exports = __webpack_public_path__ + "img/trupanion-logo.77d96cd4.png";